export default "__VITE_ASSET__Dk$2KWKL__"